// extracted by mini-css-extract-plugin
export default {"root":"SkipLink__root___dZZDH"};